<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
}
.header-custome {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.knowlg-base-wrap-sec a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
}
.knowlg-base-wrap-sec a span{margin-right: 10px; line-height: 0;}
.header-custome span {
  font-size: 15px;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h2>Login Analytics
           <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows  + ")": ""
        }}</span>
      </h2>
      <div class="knowlg-base-wrap-sec">
        <a href="/pages/knowledge-base/category-analytics/question-1"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></span> Need help with this section?</a>
      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ pageViewUserData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : pageViewUserData.length }} of {{ pageViewUserData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <!--<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>-->
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
                
          <div style="display: inline-flex;">
            <label class="ml-2">Show Unique Logins</label>
            <vs-switch class="ml-2" v-model="uniqueLoginFlg"
            />
          </div>

          <span v-show="showUpdatedTxt" style="background: #d8d6d6;margin-left: 10px"><b>Last Updated :</b> 10 Seconds Ago!!</span>
        
        </div>
        <!--ADD Attendee-->

        <vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Preview"
          :active.sync="popupActiveMail"
        >
          Subject:
          <h3>{{welcomeMailSubject}}</h3>
          <br />
          <div v-html="welcomeMailText"></div>
          <!--<quill-editor v-model="welcomeMailText"></quill-editor>-->
          <br />
          <div click="sendbtn-section">
            <vs-button color="rgb(76, 139, 246)" type="filled" @click="popupActiveMail=false">Cancel</vs-button>
            <!--<vs-button class="mail-btn" type="gradient" @click="sendMail">Send Mail</vs-button>-->
          </div>
        </vs-popup>
           <div class="vx-col mr-5" style="text-align: center">
          <label><b>Total:&nbsp;</b></label>
          <label>{{ totalLogins }}</label>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-42"
          >
            <span class="mr-2 leading-none" v-if="filtrDay == 0"><small>Filter : Today</small></span>
            <span class="mr-2 leading-none" v-else-if="[6,12,48].includes(filtrDay)"><small>Filter : {{filtrDay}} Hours</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay > 0"><small>Filter : {{filtrDay}} days</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay == -1"><small>Filter : All</small></span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeFilterByDays(6)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>6 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(12)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>12 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(48)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>48 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(0)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Today</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(3)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 3 days</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(7)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 7 days</span>
              </span>
            </vs-dropdown-item>
               <vs-dropdown-item @click="changeFilterByDays(15)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 15 days</span>
              </span>
            </vs-dropdown-item>
              <vs-dropdown-item @click="changeFilterByDays(30)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 30 days</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(-1)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>All</span>
              </span>
            </vs-dropdown-item>

            <!--<vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Set Inactive</span>
              </span>
            </vs-dropdown-item>-->
          </vs-dropdown-menu>
        </vs-dropdown>

                <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      
      <div class="container">
        <div class="my-5">
          <div v-show="chart != null">
            <canvas id="myChart" height="50px"></canvas>
          </div>
        </div>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="pageViewUserData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

import parser from "ua-parser-js";

// Store Module
import moduleAnalytics from "@/store/analytics/moduleAnalytics.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";
import moment from "moment-timezone";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/UserLoginCellRendererActions.vue";
import CellRendererIPAddressAction from "./cell-renderer/CellRendererIPAddressAction.vue";
import Chart from 'chart.js';
 import $ from "jquery";
 import 'jquery-ui-dist/jquery-ui';

//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var vm;
let setLiveLoginWatch;
let counter = 0;
export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererIPAddressAction
  },
  data() {
    return {
      uniqueLoginFlg : false,
      gridSelectedRows: 0,
      filtrDay: null,
      settingsData: { ShowMeetingButton: false },
      popupActiveMail: false,
      popupActiveMailUpdate: false,
      mailRecepients: [],
      welcomeMailText: null,
      welcomeMailSubject: null,
      sourcehtml: null,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      pageView_UserData: [],
      userDataForGraph: [],
      chart: null,
      loginDates: [],
      loginUserCount: [],
      showUpdatedTxt: false,
      columnDefs: [
        //{
        //  //headerName: 'ID',
        //  field: "AttendeeId",
        //  //width: 40,
        //  filter: false,
        //  checkboxSelection: true,
        //  headerCheckboxSelectionFilteredOnly: true,
        //  headerCheckboxSelection: true
        //},
        {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "First Name",
          field: "Fname",
          filter: true,
          width: 300
        },
        {
          headerName: "Last Name",
          field: "Lname",
          filter: true,
          width: 300
        },
        {
          headerName: "Email",
          field: "UserEmail",
          filter: true,
          width: 300
        },
        {
          headerName: "Login Type",
          field: "actionLabel",
          filter: true,
          width: 200
        },
        {
          headerName: "Date & Time",
          field: "ActionTimeStr",
          filter: true,
          width: 250
        },
        {
          headerName: "Device Info",
          field: "UserAgent",
          filter: true,
          width: 400
        },
         {
          headerName: "City",
          field: "city",
          filter: true,
          width: 250
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRendererIPAddressAction
      },
      totalLogins: 0,
    };
  },
  computed: {
    pageViewUserData() {
      return this.pageView_UserData;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 20;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    changeFilterByDays(days){
      this.filtrDay = days;
      if(this.uniqueLoginFlg == false){
        this.fetch_user_data(days);
      }else{
        this.fetch_user_last_login_data(days);
      }
      
    },
    fetch_user_data(filterdays) {
     // this.$vs.loading();
      this.$store
        .dispatch("analytics/fetchUserLoginData",filterdays)
        .then(res => {
          //debugger;
          var resultData = res.data;
          this.pageView_UserData = resultData;
          this.userDataForGraph = resultData;
          this.totalLogins = resultData.length;
          this.showUpdatedTxt = true;
          this.getDataForGraph();
         // this.$vs.loading.close();
        })
        .catch(err => {
          //debugger;
          /*if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }*/
          //this.$vs.loading.close();
          console.error(err);
        });
    },
    getSettings() {
      this.$vs.loading();

      this.$store.dispatch("analytics/getSettings").then(res => {
        this.settingsData = res;
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("analytics/saveSettings", {
          settingsData: this.settingsData
        })
        .then(res => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message
          });
          this.$vs.loading.close();
        });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    getFormattedDate: function(seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.getMonth();
      var year = dt.getFullYear();
      //const monthNames = [
      //  "January",
      //  "February",
      //  "March",
      //  "April",
      //  "May",
      //  "June",
      //  "July",
      //  "August",
      //  "September",
      //  "October",
      //  "November",
      //  "December"
      //];
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      var formattedValue =
        monthNames[month] + " " + day.toString() + ", " + year;
      return formattedValue;
    },
    getFormattedTime: function(seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var seconds = dt.getSeconds();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
      var formattedValue =
        hours.toString() +
        ":" +
        minutes.toString() +
        ":" +
        seconds.toString() +
        " " +
        amPM;
      return formattedValue;
    },
    getDevice: function(uastring) {
      debugger;
      var retVal = "";
      var result = parser(uastring);

      //console.log(parser);
      //console.log(result);
      //parser.setUA(uastring);
      //var result = parser.getResult();
      // this will also produce the same result (without instantiation):
      // var result = UAParser(uastring);
      if (result.device != undefined) {
        if (result.device.vendor != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.device.vendor;
          if (result.device.model != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.device.model;
          }
        }
      }
      if (result.os != undefined) {
        if (result.os.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.os.name;
          if (result.os.version != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.os.version;
          }
        }
      }
      if (result.browser != undefined) {
        if (result.browser.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.browser.name;
          if (result.browser.major != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.browser.major;
          }
        }
      }
      return retVal;
      //console.log(result.browser);        // {name: "Chromium", version: "15.0.874.106"}
      //console.log(result.device);         // {model: undefined, type: undefined, vendor: undefined}
      //console.log(result.os);             // {name: "Ubuntu", version: "11.10"}
      //console.log(result.os.version);     // "11.10"
      //console.log(result.engine.name);    // "WebKit"
      //console.log(result.cpu.architecture);   // "amd64"
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];
        var timeZone = [];

        timeZone.push("Report Exported In ")
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"'+ timezone + ' Time Zone' + '"');
        datarow.push("First Name");
        datarow.push("Last Name");
        datarow.push("Email");
        datarow.push("Login Type");
        datarow.push("Date & Time");
        datarow.push("Device Info");
        datarow.push("User Agent");
        datarow.push("IP Address");
        datarow.push("City");
        var userLoginData = [];
        userLoginData.push(datarow);
        var TimeZoneHeader = [];
		    TimeZoneHeader.push(timeZone);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var fname = row.Fname == undefined ? "" : row.Fname;
          datarow.push('"' + fname + '"');
          var lname = row.Lname == undefined ? "" : row.Lname;
          datarow.push('"' + lname + '"');
          var email = row.UserEmail == undefined ? "" : row.UserEmail;
          datarow.push('"' +  email + '"');
          var loginType = row.actionLabel == undefined ? "" : row.actionLabel;
          datarow.push('"' + loginType + '"');
          var dateTime = row.ActionTimeStr == undefined ? "" : row.ActionTimeStr;
          datarow.push('"'+ dateTime + '"');
          var deviceInfo = row.DeviceInfo == undefined ? "" : row.DeviceInfo;
          datarow.push('"' + deviceInfo + '"');
          var userAgent = row.UserAgent == undefined ? "" : row.UserAgent;
          datarow.push('"' + userAgent + '"');
           var ipAddress = row.userIp == undefined ? "" : row.userIp;
          datarow.push('"' + ipAddress + '"');
          var city = row.city == undefined ? "" : row.city;
          datarow.push('"' + city + '"');
          userLoginData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader.forEach(function(rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        userLoginData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "LoginAnalyticsData" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one login analytics data to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm:ss A");
      return date;
    },
    TimeFormateForGraph: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("YYYY-MM-DD hh:mm:ss A");
      return date;
    },
    getDataForGraph: function () {
	this.loginDates = [];
	this.loginUserCount = [];
	var names = [];
	var loginData = this.userDataForGraph;
	var date;
	var counter = 1;
	loginData.forEach(doc => {
		date = doc.ActionTimeStr;
		this.loginDates.push(date);
		this.loginUserCount.push(counter);
		names.push(doc.Uname);
		counter++;
	});

	if (this.chart != null) {
		this.chart.destroy();
	}

	var ctx = document.getElementById("myChart");
	this.chart = new Chart(ctx, {
		type: "line",
		data: {
			labels: this.loginDates,
			datasets: [{
				label: "User",
				backgroundColor: "#4c8af6",
				borderColor: "#4c8af6",
				fill: false,
				data: this.loginUserCount.reverse()
			}]
		},
		options: {
			legend: {
				display: false
			},
			title: {
				display: false,
				text: "Real Time Login"
			},
			tooltips: {
				callbacks: {
					label: function (tooltipItem, data) {
						var label =
							data.datasets[tooltipItem.datasetIndex].label || "";

						if (label) {
							label += ": ";
						}

						label += names[tooltipItem.index];
						return label;
					}
				}
			},
			scales: {
				xAxes: [{
					type: "time",
					time: {
						unit: "days",
						displayFormats: {
							days: "M/DD"
						},
						tooltipFormat: "MM-DD hh:mm:ss A"
					},
					scaleLabel: {
						display: true,
						labelString: "Date/Time"
					}
				}],
				yAxes: [{
					scaleLabel: {
						display: true,
						labelString: "No. of Logins"
					},
					ticks: {
						callback: function (value, index, values) {
							return value;
						}
					}
				}]
			}
		}
	});
},
  fetch_user_last_login_data(filterdays) {
      //this.$vs.loading();
      this.$store
        .dispatch("analytics/fetchUserLastLoginData",filterdays)
        .then(res => {
          //debugger;
          var resultData = res.data;
          this.pageView_UserData = resultData;
          this.userDataForGraph = resultData;
          this.totalLogins = resultData.length;
          this.showUpdatedTxt = true;
          this.getDataForGraph();
          //this.$vs.loading.close();
        })
        .catch(err => {
          //this.$vs.loading.close();
          console.error(err);
        });
    },
  },
    beforeRouteLeave: function(to, from, next) {
    if(setLiveLoginWatch){
      clearInterval(setLiveLoginWatch);
    }
    next(true);
  },
  mounted() {
        $(document).ready(function(){
  $(document).mousemove(function(event){
      counter = 0
  });
  });
    vm = this;
    this.gridApi = this.gridOptions.api;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }

            setLiveLoginWatch = setInterval(function () {
              counter += 10;
                if(counter == 300){
               alert("Please click 'OK' to keep working");
               }else{
                 vm.showUpdatedTxt = false;
                 vm.changeFilterByDays(vm.filtrDay)
               }
          },10000);
  },
  created() {
    //debugger;
    /*if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })*/
    if (!moduleAnalytics.isRegistered) {
      this.$store.registerModule("analytics", moduleAnalytics);
      moduleAnalytics.isRegistered = true;
    }
    //this.$store.dispatch("analytics/fetchUserJourneyData").catch(err => {
    //  //console.error(err)
    //});
    this.fetch_user_data(0);
    this.filtrDay = 0;

    /*let html = "Subject: BNI Cochin Welcomes You to Celebrate Regional Awards & Business Conclave 2020!";
    html += "\n\nHi @@attendee@@, \n\nYou are successfully registered to the Regional Awards & Business Conclave 2020 by BNI Cochin. \nBelow is the link and credentials to login:";
    html += "\n\nLogin URL: https://bni.e2m.live/  \n\nUsername: Registered Email Address \nPin: @@UserPin@@ ";
    html += "\n\nSee you at the Conclave!";
    html +="\n\nThank you,\nTeam e2m OnAir";
    html += "\n\nThis is an auto-generated e-mail. Please do not reply to this e-mail. For any queries or help, please e-mail to support@e2m.live";
    this.welcomeMailText = html;*/
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.notification-msg {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>